import React from 'react'
import MediaHome from './MediaHome'
import BottomNavigation from './../BottomNavigation'
import { ROUTE_FRIENDS, ROUTE_PERFORMANCES } from '../../constants'

function Media({ location, children }) {

  if (location.pathname !== '/media') {
    return (
      <div>
        {children}
        <BottomNavigation previousText="Prestations" previousLink={ROUTE_PERFORMANCES} nextText="Amis" nextLink={ROUTE_FRIENDS} />
      </div>
    );
  } else {
    return (
      <div>
        <MediaHome/>
        <BottomNavigation previousText="Prestations" previousLink={ROUTE_PERFORMANCES} nextText="Amis" nextLink={ROUTE_FRIENDS} />
      </div>
    );
  }
}

export default Media



/** WEBPACK FOOTER **
 ** ./src/components/Media/Media.jsx
 **/